import { z } from 'zod';

export const CompleteProductRegistrationResponseSchema = z.object({
  productId: z.uuid(),
});

export type CompleteProductRegistrationResponse = z.infer<
  typeof CompleteProductRegistrationResponseSchema
>;

export const DiscardProductDraftResponseSchema = z.object({
  productId: z.uuid(),
});

export type DiscardProductDraftResponse = z.infer<typeof DiscardProductDraftResponseSchema>;
